// FactionTypes.ts

import { MultiplayerGameType } from './multiplayerGame';

export enum GameFactionSide {
  Black = 'black',
  White = 'white',
  Blue = 'blue',
  Red = 'red',
  Purple = 'purple',
  Green = 'green',
  Orange = 'orange',
  Pink = 'pink',
}
export interface FactionInfo {
  side: GameFactionSide;
  color: string;
  name: string;
}

export const factionData: Record<GameFactionSide, FactionInfo> = {
  [GameFactionSide.Black]: {
    side: GameFactionSide.Black,
    color: '#666766',
    name: 'Black Side',
  },
  [GameFactionSide.White]: {
    side: GameFactionSide.White,
    color: '#cccccc',
    name: 'White Side',
  },
  [GameFactionSide.Blue]: {
    side: GameFactionSide.Blue,
    color: '#1C6ACB',
    name: 'Blue Side',
  },
  [GameFactionSide.Red]: {
    side: GameFactionSide.Red,
    color: '#DB2E2E',
    name: 'Red Side',
  },
  [GameFactionSide.Purple]: {
    side: GameFactionSide.Purple,
    color: '#BF54C9',
    name: 'Purple Side',
  },
  [GameFactionSide.Green]: {
    side: GameFactionSide.Green,
    color: '#85CC12',
    name: 'Green Side',
  },
  [GameFactionSide.Orange]: {
    side: GameFactionSide.Orange,
    color: '#EB8C36',
    name: 'Orange Side',
  },
  [GameFactionSide.Pink]: {
    side: GameFactionSide.Pink,
    color: '#B65C9F',
    name: 'Pink Side',
  },
};

export function getColorForIndex(index: number): string {
  const keys = Object.keys(GameFactionSide).slice(2); // Exclude Black and White
  const safeIndex = index % keys.length;
  return factionData[keys[safeIndex] as GameFactionSide].color;
}

export const gameFactionOrder = new Map<MultiplayerGameType, GameFactionSide[]>(
  [
    [
      MultiplayerGameType.JOYAChess,
      [
        GameFactionSide.Blue,
        GameFactionSide.Red,
        GameFactionSide.Purple,
        GameFactionSide.Green,
      ],
    ],
    [
      MultiplayerGameType.FiveLoavesTwoFish,
      [
        GameFactionSide.Blue,
        GameFactionSide.Red,
        GameFactionSide.Purple,
        GameFactionSide.Green,
      ],
    ],
    [
      MultiplayerGameType.TicTacToe,
      [
        GameFactionSide.Blue,
        GameFactionSide.Red,
        GameFactionSide.Purple,
        GameFactionSide.Green,
      ],
    ],
    [
      MultiplayerGameType.Gomoku,
      [
        GameFactionSide.Blue,
        GameFactionSide.Red,
        GameFactionSide.Purple,
        GameFactionSide.Green,
      ],
    ],
    [
      MultiplayerGameType.ChineseChess,
      [GameFactionSide.Black, GameFactionSide.Red],
    ],
    [MultiplayerGameType.Chess, [GameFactionSide.Black, GameFactionSide.White]],
    [MultiplayerGameType.Go, [GameFactionSide.Black, GameFactionSide.White]],
  ],
);

export function getRandomGameFactionOrderFaction(
  gameType: MultiplayerGameType,
): FactionInfo | undefined {
  const factions = gameFactionOrder.get(gameType);
  if (!factions || factions.length === 0) {
    console.error('No factions available for this game type:', gameType);
    return undefined;
  }
  const randomIndex = Math.floor(Math.random() * factions.length);
  const factionSide = factions[randomIndex];
  if (!factionSide) {
    console.error('Random index out of bounds:', randomIndex);
    return undefined;
  }
  return factionData[factionSide];
}
